angular.module('spaceChat.common')
   .factory('spaceChatAgentSvc', [ 'IHestiaRestServiceAbstractDef',
    function(IHestiaRestServiceAbstractDef) {

    var SpaceChatAgent = function()
    {
      IHestiaRestServiceAbstractDef.apply(this, arguments);

      this.basePattern = '{host}{port}{path}/{businessArea}/{apiString}/{resource}{id}{subResource}';
      this.businessArea = 'space-chat';
      this.resource = 'agent';
    };

    return new SpaceChatAgent();
  }])
;